var _style, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayCinedOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00868E;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_2_",
    className: "st0",
    cx: 200,
    cy: 200,
    r: 200
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    className: "st1",
    d: "M121,200v-68.7c0-20.4,22.1-33.1,39.7-22.9l59.5,34.4l59.5,34.4c17.6,10.2,17.6,35.6,0,45.8 l-59.5,34.4l-59.5,34.4c-17.6,10.2-39.7-2.5-39.7-22.9V200z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCinedOn);
export default __webpack_public_path__ + "static/media/play_cined_on.987ef8500196ac36e8a3a4b9daa50c72.svg";
export { ForwardRef as ReactComponent };